import React, { useEffect } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import styled from 'styled-components';
import 'antd/dist/antd.css';

import BookingRoute from '../../pages/NewBooking';
import {
  ROUTE_PREFIX_BOOKING,
  ROUTE_PREFIX_PRE_APPT,
  ROUTE_PREFIX_WORKFLOW_ID,
  ROUTES,
  ROUTES_PRE_APPT,
} from '../../constants/routes';
import Notification from '../../pages/Notification';
import { intercomService } from '../appServices';
import GlobalStyle from './GlobalStyle';
import LandingPageWrapper from '../../pages/LandingPage/LandingPageWrapper';
import PaymentFinishPage from '../../pages/PreApptPayment/PaymentFinishPage';
import NoApptOrPaymentInfoPage from '../../pages/PreApptPayment/NoApptOrPaymentInfoPage';
import PreApptPayment from '../../pages/PreApptPayment';

// The bottom padding lets every page's last line scroll clear of the
// floating chat launcher (48px, 20px from the bottom or above ActionBar).
const Container = styled.div`
  max-width: 760px;
  margin: auto;
  padding-bottom: 72px;
`;

const App = () => {
  useEffect(() => {
    intercomService.initialize();
  }, []);

  return (
    <Container>
      <GlobalStyle />
      <Switch>
        <Route
          exact
          path={ROUTE_PREFIX_WORKFLOW_ID}
          render={({ location }) => (
            <Redirect
              to={{
                pathname: ROUTE_PREFIX_BOOKING + location.pathname,
                search: location.search,
              }}
            />
          )}
        />

        <Route
          exact
          path={ROUTE_PREFIX_WORKFLOW_ID + ROUTES.NEW_BOOKING}
          render={({ location }) => (
            <Redirect
              to={{
                pathname: ROUTE_PREFIX_BOOKING + location.pathname,
                search: location.search,
              }}
            />
          )}
        />

        <Route
          exact
          path={ROUTE_PREFIX_WORKFLOW_ID + ROUTES.NOTIFICATION}
          render={({ location }) => (
            <Redirect
              to={{
                pathname: ROUTE_PREFIX_BOOKING + location.pathname,
                search: location.search,
              }}
            />
          )}
        />

        <Route
          path={
            ROUTE_PREFIX_BOOKING + ROUTE_PREFIX_WORKFLOW_ID + ROUTES.NEW_BOOKING
          }
        >
          <BookingRoute />
        </Route>

        <Route exact path={ROUTE_PREFIX_BOOKING + ROUTE_PREFIX_WORKFLOW_ID}>
          <LandingPageWrapper />
        </Route>

        <Route
          path={
            ROUTE_PREFIX_BOOKING +
            ROUTE_PREFIX_WORKFLOW_ID +
            ROUTES.NOTIFICATION
          }
        >
          <Notification />
        </Route>

        <Route
          path={
            ROUTE_PREFIX_PRE_APPT +
            ROUTE_PREFIX_WORKFLOW_ID +
            ROUTES_PRE_APPT.FINISH_PAYMENT
          }
        >
          <PaymentFinishPage />
        </Route>

        <Route
          path={
            ROUTE_PREFIX_PRE_APPT +
            ROUTE_PREFIX_WORKFLOW_ID +
            ROUTES_PRE_APPT.NO_APPT
          }
        >
          <NoApptOrPaymentInfoPage />
        </Route>

        <Route path={ROUTE_PREFIX_PRE_APPT + ROUTE_PREFIX_WORKFLOW_ID}>
          <PreApptPayment />
        </Route>
      </Switch>
    </Container>
  );
};

export default App;
